<template>
  <div class="cotton-smoldering-search-wrap">
    <el-form ref="form" :model="model" label-suffix=":" :inline="true" size="small" :rules="rules">
      <el-form-item :label="$t('设备')" prop="sn">
        <el-select
          v-model="model.sn"
          clearable
          multiple
          collapse-tags
          :placeholder="$t('请选择设备')"
        >
          <el-option v-for="v in deviceList" :key="v.sn" :label="v.name" :value="v.sn">
            <span>{{ v.name }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('统计类型')" prop="busiType">
        <el-select
          v-model="model.busiType"
          multiple
          clearable
          collapse-tags
          size="small"
          :placeholder="$t('请选择')"
        >
          <el-option v-for="v in statTypeList" :key="v.value" :label="v.label" :value="v.value">
            <span>{{ $t(v.label) }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('报警时间')" prop="dateRange">
        <el-date-picker
          v-model="model.dateRange"
          type="datetimerange"
          :range-separator="$t('至')"
          :start-placeholder="$t('开始日期')"
          :end-placeholder="$t('结束日期')"
          value-format="timestamp"
          @change="dateChange"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="validateEvent('search')" :loading="loading">
          {{ $t('查询') }}
        </el-button>
        <el-button
          type="primary"
          size="mini"
          @click="validateEvent('export')"
          :loading="exportLoading"
        >
          {{ $t('导出') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
// import { getTime, toTimestamp } from '@/utils/date';
import { mapState } from 'vuex';
import { getDevicesList } from '@/api/baseInfo';
import { busiOptions } from '../data';

export default {
  inject: ['getDeviceTypeList'],
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    operation: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    exportLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      statTypeList: [...busiOptions],
      officeTreeParams: {
        data: [],
        checkStrictly: true,
        multiple: true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        }
      },
      deviceList: []
    };
  },
  computed: {
    ...mapState('socket', ['deviceSNMap']),
    deviceTypeList() {
      return this.getDeviceTypeList();
    }
  },
  methods: {
    dateChange(_val) {
      // if (!val || !val[0] || !val[1]) return;
      // const begin = toTimestamp(val[0], 'm');
      // const end = toTimestamp(val[1], 'm');
      // const range = getTime('h') * 24;
      // if (end - begin > range) {
      //   this.model.dateRange.splice(0, Infinity, begin, begin + getTime('h'));
      // } else {
      //   this.model.dateRange.splice(0, Infinity, begin, end);
      // }
    },

    validateEvent(key) {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit(key, this.model);
        } else {
          return false;
        }
      });
    },
    async getDeviceList() {
      try {
        const { officeId } = this.model;

        const res = await getDevicesList({
          officeId: officeId,
          deviceModel: this.deviceTypeList.map(e => e.value)
        });
        this.deviceList = res.data;
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    this.getDeviceList();
  }
};
</script>

<style></style>
